/**
 * Previously auto-advanced web users past intro_pending.
 * Now a no-op: new users start at setup_pending, intro is purely client-side UI.
 * Kept to avoid breaking imports.
 */
export const useWebAutoAdvanceIntro = (_onboardingStep: string | undefined) => {};
